import React, { useRef } from 'react';
import { Dropdown } from 'semantic-ui-react';
import { useDispatch } from 'react-redux';
import { ValidMe } from 'businessLogic/validation.js';
import Txt from '../../../inputs/textInput.js';
import objectAssign from 'object-assign';
import { updateOrgUnitGeneralInfoForm, orgNameDuplicate, setOrgGeneralInfoFormTrim } from 'actions/organisation.js';

const ResourceCentreOptions = [
  { value: 'true', text: APP.LANGUAGE.Yes },
  { value: 'false', text: APP.LANGUAGE.No },
];
const ReportingTagsOptions = [
  { value: 'true', text: APP.LANGUAGE.Yes },
  { value: 'false', text: APP.LANGUAGE.No },
];

export default function CenterPanel(props) {
  const txtRef = useRef('orgNameAbb');
  const dispatch = useDispatch();

  const changeShortUrl = (i, v) => {
    let updatedProperties = {};
    const urlValue = props.shortUrls[v.value].text;
    updatedProperties = { providerUrl: urlValue };
    let editedOrgUnitGeneralInfoForm = objectAssign({}, props.updatedOrgUnitGeneralInfoForm, updatedProperties);
    dispatch(updateOrgUnitGeneralInfoForm(editedOrgUnitGeneralInfoForm));
  };
  const onChangeInfo = (event, v) => {
    let updatedProperties = {};
    if (event.target) {
      switch (event.target.name) {
        case 'orgName':
          dispatch(orgNameDuplicate(false));
          updatedProperties = { name: event.target.value };
          break;
        case 'orgAbbrev':
          updatedProperties = { abbreviatedName: event.target.value };
          break;
        case 'privacyPolicyUrl':
          updatedProperties = { privacyPolicyUrl: event.target.value };
          break;
        case 'troubleshootingUrl':
          updatedProperties = { troubleshootingUrl: event.target.value };
          break;
        case 'termsAndConditionUrl':
          updatedProperties = { termsAndConditionUrl: event.target.value };
          break;
        case 'orgLevelCallerEntryURL':
          updatedProperties = { callerEntryPage: event.target.value };
          break;
        default:
          break;
      }

      let editedOrgUnitGeneralInfoForm = objectAssign({}, props.updatedOrgUnitGeneralInfoForm, updatedProperties);

      dispatch(updateOrgUnitGeneralInfoForm(editedOrgUnitGeneralInfoForm));
    }
  };

  const onChangeAllowResourceCentre = (event, data) => {
    const selectedValue = data.value == 'true';

    let currentForm = objectAssign({}, props.updatedOrgUnitGeneralInfoForm);
    currentForm.featuresEnabled.resourceCentre = selectedValue;

    let editedOrgUnitGeneralInfoForm = objectAssign({}, props.updatedOrgUnitGeneralInfoForm, currentForm);
    dispatch(updateOrgUnitGeneralInfoForm(editedOrgUnitGeneralInfoForm));
  };

  const onChangeAllowReportingTags = (event, data) => {
    const selectedValue = data.value == 'true';

    let currentForm = objectAssign({}, props.updatedOrgUnitGeneralInfoForm);
    currentForm.featuresEnabled.reportingtags = selectedValue;

    let editedOrgUnitGeneralInfoForm = objectAssign({}, props.updatedOrgUnitGeneralInfoForm, currentForm);
    dispatch(updateOrgUnitGeneralInfoForm(editedOrgUnitGeneralInfoForm));
  };

  const onGeneralInfoElementBlur = () => {
    dispatch(setOrgGeneralInfoFormTrim());
  };

  const orgNameFocusOut = (value) => {
    onGeneralInfoElementBlur();
    //on focus out we will have to copy it to org abb field if the conditions are met
    if (
      !(
        props.updatedOrgUnitGeneralInfoForm.abbreviatedName &&
        props.updatedOrgUnitGeneralInfoForm.abbreviatedName.length > 0
      ) &&
      value.length > 2 &&
      value.length <= 16
    ) {
      let updatedProperties = { abbreviatedName: value };
      let editedOrgUnitGeneralInfoForm = objectAssign({}, props.updatedOrgUnitGeneralInfoForm, updatedProperties);

      dispatch(updateOrgUnitGeneralInfoForm(editedOrgUnitGeneralInfoForm));

      const orgNameAbbRef = txtRef.current.value;
      setTimeout(() => {
        //we fire the handle change after 300 ms, as by that time the field values would have taken place
        //The validation does not kick in, so this helps
        orgNameAbbRef.handleChange(value);
      }, 300);
    }
  };

  const styleForA = {
    wordWrap: 'break-word',
    width: '100%',
  };

  const featuresEnabledResourceCentre =
    !!props.updatedOrgUnitGeneralInfoForm.featuresEnabled &&
    !!props.updatedOrgUnitGeneralInfoForm.featuresEnabled.resourceCentre;

  const featuresEnabledReportingtags =
    !!props.updatedOrgUnitGeneralInfoForm.featuresEnabled &&
    !!props.updatedOrgUnitGeneralInfoForm.featuresEnabled.reportingtags;

  const editFeatureSetting = [
    <div className="mrtm clearfix" key="resourceCentre">
      <span className="sms-title inline-flex mrtm mrrs pdbxs">
        {APP.LANGUAGE.OrgUnitGeneralInfo.AllowResourceCentreCaption}
      </span>
      <Dropdown
        tabIndex="7"
        className="inline-input inline-flex non-transparent-input features-enabled-input"
        defaultValue={featuresEnabledResourceCentre.toString()}
        onChange={onChangeAllowResourceCentre}
        selection
        options={ResourceCentreOptions}
      />
    </div>,
    <div className="mrtm clearfix" key="reportingtags">
      <span className="sms-title inline-flex mrtm mrrs pdbxs">
        {APP.LANGUAGE.OrgUnitGeneralInfo.AllowReportingTagsCaption}
      </span>
      <Dropdown
        tabIndex="8"
        className="inline-input inline-flex non-transparent-input features-enabled-input"
        defaultValue={featuresEnabledReportingtags.toString()}
        onChange={onChangeAllowReportingTags}
        selection
        options={ReportingTagsOptions}
      />
    </div>,
  ];

  const editVersionMarkup = (
    <div className="ui form">
      <ValidMe
        validmefor="length@3-120"
        trim={true}
        validmemessage={APP.LANGUAGE.Errors.OrgUnitInvalidLength}
        group="generalInfoOrgUnitForm"
        fieldClasses="mrtl"
      >
        <Txt
          tabIndex="1"
          focusme="true"
          name="orgName"
          onBlur={orgNameFocusOut}
          customOnChange={true}
          noTitle
          value={props.updatedOrgUnitGeneralInfoForm.name}
          onChange={(event) => onChangeInfo(event)}
          placeholder={APP.LANGUAGE.OrgUnitGeneralInfo.OrgUnitName}
        />
      </ValidMe>
      <ValidMe
        validmefor="length@3-16"
        group="generalInfoOrgUnitForm"
        validmemessage={APP.LANGUAGE.Errors.OrgAbbreviationLength}
        fieldClasses="mrbxl"
      >
        <Txt
          tabIndex="2"
          maxLength={16}
          name="orgAbbrev"
          ref={txtRef}
          customOnChange={true}
          noTitle
          value={props.updatedOrgUnitGeneralInfoForm.abbreviatedName}
          onChange={onChangeInfo}
          placeholder={APP.LANGUAGE.OrgUnitGeneralInfo.OrgUnitAbbrevPlaceholder}
        />
      </ValidMe>
      {props?.shortUrls?.length > 0 && props.updatedOrgUnitGeneralInfoForm.providerUrl && (
        <div className="mrtl">
          <div className="bold title-sms">{APP.LANGUAGE.CreateOrgUnit.shortUrl}</div>
          <div className="placeholder-label">
            <span>{APP.LANGUAGE.CreateOrgUnit.BaseUrlForAllWaitingAreaLink}</span>
          </div>
          <Dropdown
            className="shorturl-generalInfo-dropdown"
            options={props.shortUrls}
            defaultValue={props.shortUrls.findIndex(
              (item) => item.text === props.updatedOrgUnitGeneralInfoForm.providerUrl
            )}
            onChange={changeShortUrl}
            fluid
            selection
          />
        </div>
      )}
      <div className="bold title-sms mrtl">Information for callers</div>
      <ValidMe validmefor="httpOrHttpsURL@canBeEmpty" group="generalInfoOrgUnitForm" fieldClasses="mrtl">
        <Txt
          tabIndex="3"
          name="privacyPolicyUrl"
          customOnChange={true}
          noTitle
          value={props.updatedOrgUnitGeneralInfoForm.privacyPolicyUrl}
          onChange={(event) => onChangeInfo(event)}
          placeholder={APP.LANGUAGE.OrgUnitGeneralInfo.PrivatePolicyURLPlaceholder}
        />
      </ValidMe>
      <ValidMe validmefor="required&httpOrHttpsURL" group="generalInfoOrgUnitForm" fieldClasses="mrtxl">
        <Txt
          tabIndex="4"
          name="troubleshootingUrl"
          customOnChange={true}
          noTitle
          value={props.updatedOrgUnitGeneralInfoForm.troubleshootingUrl}
          onChange={(event) => onChangeInfo(event)}
          placeholder={APP.LANGUAGE.OrgUnitGeneralInfo.TroubleshootingURLPlaceholder}
        />
      </ValidMe>
      <ValidMe validmefor="required&httpOrHttpsURL" group="generalInfoOrgUnitForm" fieldClasses="mrtxl">
        <Txt
          tabIndex="5"
          name="termsAndConditionUrl"
          customOnChange={true}
          noTitle
          value={props.updatedOrgUnitGeneralInfoForm.termsAndConditionUrl}
          onChange={(event) => onChangeInfo(event)}
          placeholder={APP.LANGUAGE.OrgUnitGeneralInfo.CallerTermsOfUseURLPlaceholder}
        />
      </ValidMe>
      <ValidMe validmefor="httpOrHttpsURL@canBeEmpty" group="generalInfoOrgUnitForm" fieldClasses="mrbnull no-gap">
        <Txt
          tabIndex="6"
          name="orgLevelCallerEntryURL"
          customOnChange={true}
          labelRelativeRenderOnTop
          noTitle
          notRenderPlaceholderAsTitle={true}
          titlePlaceholder={APP.LANGUAGE.OrgUnitGeneralInfo.CallerEntryURLCaption}
          value={props.updatedOrgUnitGeneralInfoForm.callerEntryPage}
          onChange={(event) => onChangeInfo(event)}
          placeholder={
            props.isOnMobileOrTablet
              ? APP.LANGUAGE.OrgUnitGeneralInfo.CallerEntryURLPlaceholderForMobile
              : APP.LANGUAGE.OrgUnitGeneralInfo.CallerEntryURLPlaceholder
          }
        />
      </ValidMe>
    </div>
  );
  const viewVersionMarkup = (
    <div>
      <div className="placeholder-label color-placeholder">{APP.LANGUAGE.OrgUnitGeneralInfo.OrgUnitName}</div>
      <div className="title-sms mrbm">{props.updatedOrgUnitGeneralInfoForm.name}</div>
      <div className="placeholder-label color-placeholder">{APP.LANGUAGE.OrgUnitGeneralInfo.OrgUnitAbbrevCaption}</div>
      <div className="title-sms mrbm">{props.updatedOrgUnitGeneralInfoForm.abbreviatedName || 'Not provided'}</div>
      <div className="bold title-sms mrtl">Information for callers</div>
      <div className="placeholder-label color-placeholder">
        {APP.LANGUAGE.OrgUnitGeneralInfo.PrivatePolicyURLCaption}
      </div>
      {props.updatedOrgUnitGeneralInfoForm.privacyPolicyUrl ? (
        <a className="mrbm" target="org-unit-general-info" href="#" style={styleForA}>
          {props.updatedOrgUnitGeneralInfoForm.privacyPolicyUrl}
        </a>
      ) : (
        <div className="title-sms mrbm">{APP.LANGUAGE.OrgUnitGeneralInfo.NotProvided}</div>
      )}
      <div className="placeholder-label color-placeholder">
        {APP.LANGUAGE.OrgUnitGeneralInfo.TroubleshootingURLCaption}
      </div>
      {props.updatedOrgUnitGeneralInfoForm.troubleshootingUrl ? (
        <a className="mrbm" target="org-unit-general-info" href="#" style={styleForA}>
          {props.updatedOrgUnitGeneralInfoForm.troubleshootingUrl}
        </a>
      ) : (
        <div className="title-sms mrbm">{APP.LANGUAGE.OrgUnitGeneralInfo.NotProvided}</div>
      )}
      <div className="placeholder-label color-placeholder">
        {APP.LANGUAGE.OrgUnitGeneralInfo.CallerTermsOfUseURLCaption}
      </div>
      {props.updatedOrgUnitGeneralInfoForm.termsAndConditionUrl ? (
        <a className="mrbm" target="org-unit-general-info" href="#" style={styleForA}>
          {props.updatedOrgUnitGeneralInfoForm.termsAndConditionUrl}
        </a>
      ) : (
        <div className="title-sms mrbm">{APP.LANGUAGE.OrgUnitGeneralInfo.NotProvided}</div>
      )}
      <div className="placeholder-label color-placeholder">{APP.LANGUAGE.OrgUnitGeneralInfo.CallerEntryURLCaption}</div>
      {props.updatedOrgUnitGeneralInfoForm.CallerEntryPage ? (
        <a className="mrbm" target="org-unit-general-info" href="#" style={styleForA}>
          {props.updatedOrgUnitGeneralInfoForm.CallerEntryPage}
        </a>
      ) : (
        <div className="title-sms mrbm">{APP.LANGUAGE.OrgUnitGeneralInfo.NotProvided}</div>
      )}
    </div>
  );
  return <div className="mrbl pdtsss">{props.updateOrView == 'update' ? editVersionMarkup : viewVersionMarkup}</div>;
}
